import { useState } from 'react';
import { api, ApiError } from '../api.js';
import { Loading, Page, useApi } from '../components.js';
import { href } from '../router.js';

interface Rev { version: number; op: string; at: string; actor: { name: string; kind: string }; data: unknown }

export function HistoryPage({ exp, kind, id }: { exp: string; kind: string; id: string }) {
  const { data, error, refetch } = useApi<{ history: Rev[] }>(`/api/expeditions/${exp}/records/${kind}/${id}/history`);
  const [msg, setMsg] = useState<string | null>(null);
  const back = kind === 'event' ? { href: href.event(exp, id), label: id } : { href: href.expedition(exp), label: 'Expedition' };
  if (!data) return <Page title={`History of ${id}`} back={back}><Loading error={error} /></Page>;
  const latest = data.history.at(-1)?.version;
  return (
    <Page title={`History of ${id}`} back={back}>
      {msg && <p className="error" role="alert">{msg}</p>}
      {[...data.history].reverse().map((r) => (
        <details className="card" key={r.version}>
          <summary>v{r.version} · {r.op} · {r.actor.kind === 'agent' ? '🤖 ' : ''}{r.actor.name} · {r.at.slice(0, 16).replace('T', ' ')}</summary>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>{JSON.stringify(r.data, null, 2)}</pre>
          {r.version !== latest && r.op !== 'delete' && (
            <button onClick={async () => {
              try { await api('POST', `/api/expeditions/${exp}/records/${kind}/${id}/restore`, { version: r.version }); setMsg(null); refetch(); }
              catch (e) { setMsg((e as ApiError).message); }
            }}>Restore v{r.version}</button>
          )}
        </details>
      ))}
    </Page>
  );
}
